
	
	import Hls from 'hls.js';

	export default {
		props: {
			videoUrl: String,
			playCover: String,
			coverWidth: {
				type: String,
				default: null
			}
		},
    	data() {
			return {
				started: false,
				video: ``,
				beforePlay: true, 	// only display big play button before it starts playing
				isPlaying: false,
				progressBar: "", 	// saved to update style
				timeRemaining: `00:00`,
				progressPercentage: 0,
				startTime: 0,
				updatingBar: false,	// condition to guarantee progress bar styling updates on user click
				showVolumeSlider: false,
			}
		},
		computed: {
			posterImg() {
				return this.playCover;
			}
		},
		watch: {
			videoUrl(v) {
				if (this.started) this.destroyHls();
				this.$nextTick(() => {
					this.updateVideo();
				});
			}
		},
		methods: {
			destroyHls() {
                this.hls.stopLoad();
                this.hls.detachMedia();
                this.hls.destroy();
            },
			updateBar() {
				const now = new Date();
				const nowTime = now.getTime();
				this.startTime = nowTime - 1100; // represents > 1 second
			},
			jumpBackward() {
				if (this.video.currentTime > 10) {
					this.video.currentTime -=  10;
				} else {
					this.video.currentTime = 0;
				}
				this.updateBar();
			},
			jumpForward() {
				if ((this.video.duration - this.video.currentTime) > 10) {
					this.video.currentTime += 10;
				} else {
					this.video.currentTime = this.video.duration;
				}
				this.updateBar();
			},
			hoverOn() {
				if (this.beforePlay) {
					let bigPlay = this.$refs.bigPlay;
					bigPlay.classList.remove("opacity-100");
					bigPlay.classList.add("opacity-75");
				}
			},
			hoverOff() {
				if (this.beforePlay) {
					let bigPlay = this.$refs.bigPlay;
					bigPlay.classList.remove("opacity-75");
					bigPlay.classList.add("opacity-100");
				}
			},
			togglePlay() {
				if(!this.started){
					this.initVideo()
				} else {
					if (this.isPlaying) {
						this.video.pause();
					} else {
						this.video.play();
					}
					this.beforePlay = false;
					this.isPlaying = !this.isPlaying;
				}

			},
			endPause() {
				this.video.pause();
				this.isPlaying = false;
			},
			showTimeRemaining() {
				let timeRemaining = this.video.duration - this.video.currentTime;
				if (isNaN(timeRemaining)) { 
					timeRemaining = "0"; 
				}
				let minutesRemaining = Math.floor(timeRemaining / 60) ;
				let secondsRemaining = Math.floor(timeRemaining % 60);
				if (minutesRemaining < 10) {
					minutesRemaining = '0' + minutesRemaining;
				}
				if (secondsRemaining < 10) {
					secondsRemaining = '0' + secondsRemaining;
				}
				this.timeRemaining = minutesRemaining + ":" + secondsRemaining;
			},
			handleProgress() {
				this.showTimeRemaining();

				const now = new Date();
				const nowTime = now.getTime();
				if (this.updatingBar) {
					this.updateBar();
				}
				if ((nowTime - this.startTime) > 1000) {
					this.startTime = nowTime;
				} else if (this.video.duration != this.video.currentTime) {
					return;
				} 
				let progressPercentage = Math.floor((this.video.currentTime / this.video.duration) * 100);
				if (isNaN(progressPercentage)) { 
					progressPercentage = 0;
				}
				this.progressPercentage = progressPercentage;
				this.$refs.progressBar.setAttribute("style", `background: linear-gradient(to right, rgb(166, 75, 30) 0%, rgb(166, 75, 30) ${this.progressPercentage}%, rgb(51, 51, 51) ${this.progressPercentage}%, rgb(51, 51, 51) 100%);`);
			},
			moveProgress() {
				this.updatingBar = true;
				const newTime = this.video.duration * (this.$refs.progressBar.value / 100);
				this.video.currentTime = newTime;
				this.handleProgress();
				this.updatingBar = false;
			},
			updateVolume(value) {
				/* method triggered in volume-slider child component */
				this.video.volume = value / 100;
			},
			toggleVolumeSlider() {
				this.showVolumeSlider = !this.showVolumeSlider;
			},
			showFullScreen() {
				/* default */
				if (this.video.requestFullscreen) {
					this.video.requestFullscreen();
				} 
				/* safari */
				else if (this.video.webkitRequestFullscreen) { 
					this.video.webkitRequestFullscreen();
				} 
				/* IE11 */
				else if (this.video.msRequestFullscreen) {
					this.video.msRequestFullscreen();
  				}
			},
			resetVideo() {
				this.video.currentTime = 0;
				this.video.pause();
				this.isPlaying = false;
				this.beforePlay = false;
				this.updatingBar = true;
				this.handleProgress();
				this.updatingBar = false;
			},
			updateVideo() {
				try {
					if (!this.started) this.initVideo();
					else {
						const hls = new Hls();
						hls.loadSource(this.videoUrl);
						hls.attachMedia(this.video);
						setTimeout(() => {
							this.togglePlay();
						}, 200);
					}	
				}
				catch {
					this.videoUrl = ``;
				}
				this.resetVideo();
			},
			initVideo() {
				try {
					this.video = this.$refs.video;
					this.hls = new Hls();
					this.hls.loadSource(this.videoUrl);
					this.hls.attachMedia(this.video);
					this.video.currentTime = 0;

					/* time stamp to only update progress bar every one second when video is playing */
					const start = new Date();
					this.startTime = start.getTime();

					this.handleProgress();
					if(!this.started){
						this.started = true
						this.$nextTick(this.togglePlay)
					}
				}
				catch {
					this.videoUrl = ``;
				}
			}
		},
		created() {
			// this.initVideo();
		},
}
